import { whitelineApi } from '@/shared/api';

export interface CreateSupportRequestRequest {
  clientRequestId: string;
  message: string;
  shipmentId?: string;
  sourceRoute: string;
}

export interface CreateSupportRequestResponse {
  requestId: string;
}

export const createSupportRequest = async (
  payload: CreateSupportRequestRequest
): Promise<CreateSupportRequestResponse> => {
  const response = await whitelineApi.post<CreateSupportRequestResponse>('/api/support/requests', payload);

  if (response.status !== 202) {
    throw new Error(`Unexpected support request response status: ${response.status}`);
  }

  return response.data;
};